import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Imprint from "../views/Imprint.vue";
import UserAgreement from "../views/UserAgreement.vue";
import Event from "../views/Event.vue";
import Streams from "../views/Streams.vue";

import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/impressum",
    name: "Imprint",
    component: Imprint
  },
  {
    path: "/nutzungsvereinbarung",
    name: "UserAgreement",
    component: UserAgreement
  },
  {
    path: "/event/:id",
    name: "Event",
    component: Event
  },
  {
    path: "/streams",
    name: "Streams",
    component: Streams,
    meta: {requiresAuth: true}
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
    meta: {requiresAuth: true}
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = firebase.auth().currentUser;
  if(requiresAuth && !isAuthenticated) next({ name: 'Home' });
  next();
})

export default router;
